import React, { Component } from 'react'
import { connect } from 'react-redux'

import DownArrow from './../../assets/Arrow_down_outline.svg'
import UpArrow from './../../assets/Arrow_up_ouline.svg'
import SolidUp from './../../assets/Arrow_up_solid.svg'
import SolidDown from './../../assets/Arrow_down_solid.svg'
import SolidBox from './../../assets/Checkmark_solid.svg'
import UncheckBox from './../../assets/uncheckMark.svg'
import SettingsIcon from './../../assets/filter-settings.svg'

import './filterPopover.scss'

class FilterPopover extends Component {
  state = {
    contentClass: ['filter-popover-content'],
    shouldShow: true,
    showSortLabels: true,
  }

  // initialize the sortingCriteria with default values or parameters passed to this component
  sortingCriteria= this.props.sortingCriteria || [];// e.g. [{"fieldName": "dtTS", "description": "Detected On", "order": "desc"}]
  // onSortByChange is a function passed from the parent component
  onSortByChange= this.props.onSortByChange instanceof Function ? this.props.onSortByChange : this.defaultOnSortChange;
  // initialize the advanceFilters with default values or parameters passed to this component
  advanceFilters= this.props.advanceFilters || []; // e.g. [{"fieldName": "rrURLYN", "description": "Remove Repeat URL", "value": "Y", "type": "boolean"}]
  // onAdvanceFilterChange is a function passed from the parent component
  onAdvanceFilterChange = this.props.onAdvanceFilterChange instanceof Function ? this.props.onAdvanceFilterChange : this.defaultOnAdvanceFilterChange;
  // initialize the filterBoxPosition with default values
  filterBoxPosition = 0;

  constructor(props) {
    super(props)
    this.updateWrapperRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    this.filterBoxPosition = document.querySelector('#filterBox').getBoundingClientRect().left
  }

  defaultOnSortChange = (sortByField, sortOrder) => {
    console.warn("default onSortChange : ", sortByField, sortOrder);
  }

  handleSortByChange = (sortByField, sortOrder) => {
    // console.log("handleSortByChange : ", sortByField, sortOrder, this.sortingCriteria);
    this.sortingCriteria.forEach(element => {
      if (element.fieldName === sortByField) {
        element.order = sortOrder;
      }
    });
    this.onSortByChange(sortByField, sortOrder, this.sortingCriteria);
  }

  defaultOnAdvanceFilterChange = (fieldName, value) => {
    console.warn("default onAdvanceFilterChange : ", fieldName, value);
  }

  handleAdvanceFilterChange = (fieldName, value) => {
    // console.log("handleAdvanceFilterChange : ", fieldName, value, this.advanceFilters);
    this.advanceFilters.forEach(element => {
      if (element.fieldName === fieldName) {
        element.value = value;
      }
    });
    this.onAdvanceFilterChange(fieldName, value, this.advanceFilters);
  }

  handleClick = () => {
    const { contentClass } = this.state
    contentClass.indexOf('filter-popover-content-after') === -1
      ? contentClass.push('filter-popover-content-after')
      : contentClass.pop()
    this.setState({ contentClass })
  }

  handleFilterClick = (filterType) => {
  }

  handleClickOutside = (event) => {
    let { contentClass } = this.state
    let contentClassIndex = contentClass.indexOf('filter-popover-remove')
    if (contentClassIndex === -1) {
      contentClass.push('filter-popover-remove')
    } else {
      contentClass.splice(contentClassIndex, 1)
    }
    this.setState({ contentClass })
  }

  render() {
    const role = this.props.tokenRoles;
    // const filters = this.props.threatFilters;// this.props.viewType === 'chart' ? this.props.chartFilters : this.props.threatFilters
    // let sDetectedOnByOrder = "desc";
    // if (filters && filters.hasOwnProperty('order') && (filters.order === 'asc' || filters.order === 'desc')) {
    //   sDetectedOnByOrder = filters.order;
    // }
    return (
      this.state.shouldShow && (
        <div id='filterBox' className="filter-popover-wrapper parent">
          <div
            ref={this.updateWrapperRef}
            onClick={this.handleClick}
            tabIndex="0"
            onBlur={(e) => this.handleClickOutside(e)}
          >
            <img
              src={SettingsIcon}
              alt=""
            />
            <div style={{left: this.filterBoxPosition>50 ? '-223px' : '-14px'}} className={this.state.contentClass.join(' ')}>
            <div className="popover-arrow" style={{right: this.filterBoxPosition>50 ? '20px' : '227px'}}></div>
               {
                this.sortingCriteria.map((criteria, index) => (
                  <div key={index} className="d-flex align-items-center filter-popover-item" onClick={() => this.handleSortByChange(criteria.fieldName, criteria.order === 'asc' ? 'desc' : 'asc')} >
                    <div className={''}>{criteria.description}</div>
                    <img style={{width: '29px', marginLeft: '3px' }} src={criteria.order === 'asc' ? SolidDown : DownArrow} alt="" srcSet="" />
                    {this.state.showSortLabels ? <span>Asc</span> : null}
                    <img style={{width: '29px', marginLeft: '3px' }} src={criteria.order === 'desc' ? SolidUp : UpArrow} alt="" srcSet="" />
                    {this.state.showSortLabels ? <span>Desc</span> : null}
                  </div>
               ))
               }
               {
                this.advanceFilters.map((filter, index) => (
                  <div key={index} className="d-flex align-items-center filter-popover-item" onClick={() => this.handleAdvanceFilterChange(filter.fieldName, filter.value === 'Y' ? 'N' : 'Y')}>
                    <div className={filter.value === 'Y' ? '' : ''}>{filter.description}</div>
                    <img style={{marginTop:'-2px'}} src={filter.value === 'Y' ? SolidBox : UncheckBox } alt="" srcSet="" />
                  </div>
               ))
               }
            </div>
          </div>
        </div>
      )
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterPopover)
